<script setup lang='ts'>
    import { onMounted, ref, Ref, watch } from 'vue';
    import { useRoute, useRouter } from 'vue-router';

    const route = useRoute();
    const router = useRouter();

    const selectedTab: Ref<string | undefined> = ref(undefined);

    onMounted(() => {
        if (route.name === 'CreateNewContract') {
            selectedTab.value = 'ContractList';
        } else if (route.name === 'CreateNewProjectMaster') {
            selectedTab.value = 'ProjectMasterList';
        } else if (route.name === 'CreateNewProject') {
            selectedTab.value = 'ProjectList';
        } else {
            selectedTab.value = route.name?.toString();
        }

        watch(selectedTab, () => {
            if (selectedTab.value === undefined) {
                return;
            }
            router.push({ name: selectedTab.value });
        });
    });

</script>

<template>
    <div>
        <h1 class="title">
            <slot name="title" />
        </h1>
        <slot name="controls" />
        <slot name="new" />
        <b-tabs
            v-model="selectedTab"
            type="is-boxed"
            class="block">
            <b-tab-item
                value="ProjectMasterList"
                label="Project masters">
                <slot name="projectmaster" />
            </b-tab-item>
            <b-tab-item
                value="FacilityList"
                label="Facilities">
                <slot name="facility" />
            </b-tab-item>
            <b-tab-item
                value="OrgUnitList"
                label="Org. units">
                <slot name="orgunits" />
            </b-tab-item>
            <b-tab-item
                value="ProjectList"
                label="Projects">
                <slot name="projects" />
            </b-tab-item>
            <b-tab-item
                value="ContractList"
                label="Contracts">
                <slot name="contracts" />
            </b-tab-item>
        </b-tabs>
    </div>
</template>
